import { variableType } from 'src/shared/inf-tabela-descricao/VariableType.enum.js'

/**
 * Mapa centralizado de esquemas de cores para tipos de variáveis
 * Facilita manutenção ao adicionar novos tipos
 */
const VARIABLE_COLOR_SCHEMES = {
  CONSUMER_UNIT_DATA: { bgColor: 'blue-2', textColor: 'blue-9', colorClass: 'chip-blue' },
  ORGANIZATION: { bgColor: 'purple-2', textColor: 'purple-9', colorClass: 'chip-purple' },
  FINANCE: { bgColor: 'green-2', textColor: 'green-9', colorClass: 'chip-green' },
  CONTROL: { bgColor: 'yellow-2', textColor: 'yellow-9', colorClass: 'chip-yellow' },
  CONCESSION_CONTRACT_TARIFF: { bgColor: 'orange-2', textColor: 'orange-9', colorClass: 'chip-orange' },
  OTHER: { bgColor: 'gray-2', textColor: 'gray-9', colorClass: 'chip-gray' }
}

/**
 * Retorna o esquema de cores para um tipo de variável
 * Usa o enum VariableType diretamente para evitar manutenção manual do mapa
 * @param {Object|Number|String} variableOrTypeId - Objeto variable com propriedade variableType ou o typeId direto
 * @returns {Object} - Objeto com propriedades { bgColor, textColor, colorClass }
 */
export function getVariableColorScheme (variableOrTypeId) {
  // Aceita tanto um objeto variable quanto um typeId diretamente
  const typeId = typeof variableOrTypeId === 'object'
    ? variableOrTypeId?.variableType
    : variableOrTypeId
  const typeStr = String(typeId || '')

  const v = variableType()

  // Procura no enum direto - encontra qualquer tipo definido no VariableType.enum.js
  for (const [enumKey, enumValue] of Object.entries(v)) {
    if (String(enumValue.key) === typeStr) {
      // Se encontrou um tipo no enum, retorna a cor correspondente
      if (VARIABLE_COLOR_SCHEMES[enumKey]) {
        return VARIABLE_COLOR_SCHEMES[enumKey]
      }
    }
  }

  return VARIABLE_COLOR_SCHEMES.OTHER
}
